module.exports = __webpack_public_path__ + "static/media/13.262776b9.jpg";